import { render, staticRenderFns } from "./SidebarItemNarrow.vue?vue&type=template&id=4e1bd474&"
import script from "./SidebarItemNarrow.vue?vue&type=script&lang=ts&"
export * from "./SidebarItemNarrow.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarItemNarrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports